// src/modules/app-views/crm/pages/Boards/modals/QuickCaptureModal/Step2Opportunity.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Col, Row } from 'antd';
import SimpleInput from 'components/SimpleComponents/SimpleInput';
import SimpleSelect from 'components/SimpleComponents/SimpleSelect';
import SimpleCurrency from 'components/SimpleComponents/SimpleCurrency';
import useZustand from 'hooks/useZustand';
import translateX from 'utils/translateX';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const Step2Opportunity = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ─────────────────────────────────────────────────────────────────────────────
  const storedParameters = useZustand('app', 'parameters');

  // ─────────────────────────────────────────────────────────────────────────────
  // 2. LOCAL VARIABLES I
  // ─────────────────────────────────────────────────────────────────────────────
  const boards = storedParameters?.modules?.crm?.boards || [];
  const temperatures = storedParameters?.modules?.crm?.temperatures || [];
  const sources = storedParameters?.modules?.crm?.sources || [];

  const boardOptions = boards.map(b => ({ value: b.uid, label: b.title, text: b.title }));

  const temperatureOptions = temperatures.map(t => ({
    value: t.uid,
    text: translateX(t.label),
  }));

  const sourceOptions = sources
    .filter(s => !s.removed)
    .map(s => ({ value: s.uid, text: translateX(s.label) }));

  const opportunityTypeOptions = [
    { value: 'sale', text: translateX('sale') },
    { value: 'partner', text: translateX('partner') },
  ];

  // ─────────────────────────────────────────────────────────────────────────────
  // 3. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div className="p-2">
      <Row gutter={16}>
        <Col xs={24}>
          <SimpleInput
            name="opportunity"
            label="opportunity_description"
            required
          />
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <SimpleSelect
            name="opportunityType"
            label="opportunity_type"
            options={opportunityTypeOptions}
          />
        </Col>
        <Col xs={24} sm={12}>
          <SimpleSelect
            name="boardUid"
            label="board"
            options={boardOptions}
          />
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <SimpleSelect
            name="temperatureUid"
            label="temperature"
            options={temperatureOptions}
          />
        </Col>
        <Col xs={24} sm={12}>
          <SimpleSelect
            name="opportunitySource"
            label="opportunitySource"
            options={sourceOptions}
          />
        </Col>
      </Row>

      <Row gutter={16}>
        <Col xs={24} sm={12}>
          <SimpleCurrency
            name="approximateValue"
            label="approximate_value"
          />
        </Col>
      </Row>
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default Step2Opportunity;
